"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quickWeiValuePow = void 0;
const ethers_1 = require("ethers");
function quickWeiValuePow(value, power, splitter = 1000) {
    if (power.isZero()) {
        return ethers_1.constants.WeiPerEther;
    }
    else if (power.lte(splitter)) {
        return value.pow(power).div(ethers_1.constants.WeiPerEther.pow(power.sub(1)));
    }
    else {
        const reducedPower = power.div(splitter);
        const restPower = power.sub(reducedPower.mul(splitter));
        let result = quickWeiValuePow(value.pow(splitter).div(ethers_1.constants.WeiPerEther.pow(splitter - 1)), reducedPower, splitter);
        for (let i = 0; i < restPower.toNumber(); i++) {
            result = result.mul(value).div(ethers_1.constants.WeiPerEther);
        }
        return result;
    }
}
exports.quickWeiValuePow = quickWeiValuePow;
//# sourceMappingURL=quickWeiValuePow.js.map